<template>
  <div class="final">
    <h1 class="title">Já pode começar a sua nova experiência</h1>
    <p class="sub">O teu trial de 7 dias está activo. Explora a plataforma e começa a crescer.</p>
    <button class="btn-orange" @click="$emit('done')">IR PARA A DASHBOARD</button>
  </div>
</template>

<script>
export default { name: "OStep7" };
</script>

<style scoped lang="scss">
.final      { max-width: 460px; color: #fff; }
.title      { font-size: 28px; font-weight: 800; margin-bottom: 12px; line-height: 1.2; }
.sub        { font-size: 15px; opacity: .75; margin-bottom: 32px; line-height: 1.6; }
.btn-orange { display: inline-flex; align-items: center; justify-content: center; padding: 14px 32px; border: none; border-radius: 10px; background: #ff825d; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; box-shadow: 0 4px 16px rgba(255,130,93,.35); &:hover { background: #e86b45; } }
</style>
